// These events are linked to the Actions.

import Action, { ActionGroup } from "./Action";
import { AddAction, DeleteAction, MoveAction, ReplaceAction } from "./PatchAction";

export interface Event {
	applyContext(context: string): void;
	toAction(): Action;
}

export class ChangeEvent implements Event {
	private path: string;
	private readonly oldValue: unknown;
	private readonly newValue: unknown;

	constructor(path: string, oldValue: unknown, newValue: unknown) {
		this.path = path;
		this.oldValue = oldValue;
		this.newValue = newValue;
	}

	public applyContext(context: string): void {
		this.path = context + this.path;
	}

	public toAction(): Action {
		return new ReplaceAction(this.path, this.oldValue, this.newValue);
	}
}

export class DeleteEvent implements Event {
	private path: string;
	private readonly oldValue: unknown;

	constructor(path: string, oldValue: unknown) {
		this.path = path;
		this.oldValue = oldValue;
	}

	public applyContext(context: string): void {
		this.path = context + this.path;
	}

	public toAction(): Action {
		return new DeleteAction(this.path, this.oldValue);
	}
}

export class AddEvent implements Event {
	private path: string;
	private readonly newValue: unknown;

	constructor(path: string, newValue: unknown) {
		this.path = path;
		this.newValue = newValue;
	}

	public applyContext(context: string): void {
		this.path = context + this.path;
	}

	public toAction(): Action {
		return new AddAction(this.path, this.newValue);
	}
}

export class MoveEvent implements Event {
	private oldPath: string;
	private newPath: string;

	constructor(oldPath: string, newPath: string) {
		this.oldPath = oldPath;
		this.newPath = newPath;
	}

	public applyContext(context: string): void {
		this.oldPath = context + this.oldPath;
		this.newPath = context + this.newPath;
	}

	public toAction(): Action {
		return new MoveAction(this.oldPath, this.newPath);
	}
}

export class EventGroup implements Event {

	private events: Event[];

	constructor(events: Event[]) {
		this.events = events;
	}

	public applyContext(context: string): void {
		this.events.forEach(event => event.applyContext(context));
	}

	public toAction(): Action {
		return new ActionGroup(this.events.map(event => event.toAction()));
	}
}